import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

type BrandKey = 'staging' | 'trendydcb' | 'default' | string;

@Injectable({ providedIn: 'root' })
export class BrandingService {
  private brand$ = new BehaviorSubject<BrandKey>('default');

  private assetBases: Record<string, string> = {
    staging: 'assets/images/brands/staging/',
    trendydcb: 'assets/images/brands/trendydcb/',
    default: 'assets/images/brands/default/',
  };
  brandName$: Observable<string> = this.brandStream.pipe(map(() => this.brandName));

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  initFromHost() {
    if (!isPlatformBrowser(this.platformId)) return;
    const host = this.document.location.hostname;
    const firstLabel = host.split('.')[0] || 'default';
    const brand = firstLabel === 'www' ? 'default' : firstLabel;
    this.brand$.next(brand);
  }

  get brandStream() {
    return this.brand$.asObservable();
  }

  get currentBrand(): BrandKey {
    return this.brand$.value;
  }

  getBasePath(): string {
    return this.assetBases[this.currentBrand] ?? this.assetBases['default'];
  }
  asset(path: string) {
    return this.getBasePath() + path.replace(/^\/+/, '');
  }
  // branding.service.ts

  private brandNames: Record<string, string> = {
    staging: 'VMS',
    trendydcb: 'TRENDY DCB',
    default: 'VMS',
  };
  
  get brandName(): string {
    return this.brandNames[this.currentBrand] ?? this.brandNames['default'];
  }
  


}
